/** Shared palette for the printable child report. */

export const HONEY = {
  /** Page and panel background. */
  light: "#FFF8E7",
  /** Gradient partner for `light`. */
  mid: "#FFE9B0",
  /** Card background: barely-there warm white, so photos and text stay crisp. */
  card: "#FFFDF7",
  border: "#F2C14E",
};

export const PLUM = {
  /** Matches theme.ts primary. */
  main: "#5d1f4f",
  soft: "#8a5480",
};
